import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59dfa57e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "q-gutter-md row justify-center"
}
const _hoisted_2 = {
  key: 0,
  class: "text-primary-darker bg-warning-light rounded-borders q-pa-md"
}
const _hoisted_3 = {
  key: 0,
  class: "text-primary-darker bg-warning-light rounded-borders q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_email_import_form = _resolveComponent("email-import-form")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    "confirm-label": _ctx.t('UPLOAD'),
    title: _ctx.t('IMPORT_EMAILS_TITLE'),
    onCancel: _ctx.cancel,
    onHide: _ctx.cancel,
    onConfirm: _ctx.onSubmit,
    "disable-confirm": _ctx.loading || _ctx.failed || _ctx.longNote,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_form, {
        id: "email-import",
        ref: "emailImport"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, {
            class: _normalizeClass([{ 'q-pb-md': !_ctx.isManager && !_ctx.isUploadInMeeting && _ctx.emailWarnings.length === 0 }, "bg-white email-card"]),
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_separator),
              _createVNode(_component_q_card_section, { class: "q-pt-md q-pb-xs q-px-lg" }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_q_spinner, {
                          color: "primary",
                          size: "5em"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.parsedEmails.length)
                          ? (_openBlock(), _createBlock(_component_q_list, {
                              key: 0,
                              class: _normalizeClass([{ 'q-pb-md': !_ctx.isUploadInMeeting }, "rounded-borders"])
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedEmails, (email, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (_ctx.emailsToImport[email.dobjId.toString()])
                                      ? (_openBlock(), _createBlock(_component_email_import_form, {
                                          key: 0,
                                          "default-opened": index === 0,
                                          "is-meeting": _ctx.isUploadInMeeting,
                                          onUpdateNote: _ctx.manageConfirm,
                                          modelValue: _ctx.emailsToImport[email.dobjId.toString()],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.emailsToImport[email.dobjId.toString()]) = $event)
                                        }, null, 8, ["default-opened", "is-meeting", "onUpdateNote", "modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (index > 1)
                                      ? (_openBlock(), _createBlock(_component_q_separator, {
                                          key: 1,
                                          class: "q-mt-lg"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _: 1
              }),
              (!_ctx.loading && _ctx.state === 'FAILED')
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    class: _normalizeClass([_ctx.isUploadInMeeting ? 'q-pt-md q-pb-xs' : 'q-pt-xs q-pb-lg', "q-px-lg"])
                  }, {
                    default: _withCtx(() => [
                      (_ctx.error.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_q_list, { class: "q-px-md" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item, {
                                  dense: "",
                                  class: "warning-item"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, {
                                      avatar: "",
                                      class: "q-pa-none"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          name: _ctx.ICONS_NAME.WARNING_SOLID,
                                          class: "text-warning"
                                        }, null, 8, ["name"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.error), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (!_ctx.loading && _ctx.emailWarnings.length)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 1,
                    class: _normalizeClass([_ctx.isUploadInMeeting ? 'q-pt-md q-pb-xs' : 'q-pt-xs q-pb-lg', "q-px-lg"])
                  }, {
                    default: _withCtx(() => [
                      (_ctx.emailWarnings.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_q_list, { class: "q-px-md" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailWarnings, (message, index) => {
                                  return (_openBlock(), _createBlock(_component_q_item, {
                                    key: index,
                                    dense: "",
                                    class: "warning-item"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, {
                                        avatar: "",
                                        class: "q-pa-none"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            name: _ctx.ICONS_NAME.WARNING_SOLID,
                                            class: "text-warning"
                                          }, null, 8, ["name"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(message) + ".", 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (_ctx.isUploadInMeeting && _ctx.isManager)
                ? (_openBlock(), _createBlock(_component_q_card_section, { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, _mergeProps({
                        disable: _ctx.loading || _ctx.failed,
                        "onUpdate:modelValue": _ctx.extractAttachmentByEmail
                      }, _ctx.CHECKBOX_PROPS, {
                        modelValue: _ctx.isBodyParsed,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isBodyParsed) = $event)),
                        class: "q-ml-xs"
                      }), {
                        default: _withCtx(() => [
                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.t('IMPORT_EMAIL_MEETING')), 17)
                        ]),
                        _: 1
                      }, 16, ["disable", "onUpdate:modelValue", "modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["confirm-label", "title", "onCancel", "onHide", "onConfirm", "disable-confirm"]))
}